<template>
  <div>
    <p v-if="!city">No city selected.</p>
    <div if="city">
      <div class="columns">
    <div class="column">
      <b-field label="Owner Name">
        <b-input
            type="text"
            icon="user "
            v-model="contact.ownerName"
            placeholder="e.g. Mr. Viral Patel"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Owner Mobile">
         <b-input
         icon="mobile"
            type="text"
            v-model="contact.ownerMobile"
            placeholder="e.g. +91 8155950590"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>
  <div class="columns">
    <div class="column">
      <b-field label="Manager Name">
        <b-input
            type="text"
            icon="user "
            v-model="contact.name"
            placeholder="e.g. Mr. Viral Patel"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Manager Mobile">
         <b-input
         icon="mobile"
            type="text"
            v-model="contact.mmobile"
            placeholder="e.g. +91 8155950590"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>
     <div class="columns">
    <div class="column">
      <b-field label="Manager Email">
        <b-input
        icon="envelope"
            type="email"
            v-model="contact.memail"
            placeholder="e.g. viral@hotelgateway.in"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Hotel Contact No.">
         <b-input
            icon="phone"
            type="text"
            v-model="contact.hno"
            placeholder="e.g. 022 235365"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>
     <div class="columns">
    <div class="column">
      <b-field label="Hotel Email">
        <b-input
            icon="envelope"
            type="email"
            v-model="contact.hemail"
            placeholder="e.g. hotel@gateway.in"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Hotel Website">
         <b-input
            icon="globe"
            type="text"
            v-model="contact.hwebsite"
            placeholder="e.g. www.hotelgateway.in"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>

     
      <a class="button is-primary full-width-button" :class="{'is-loading': savingCityInformation}" @click="saveCityInformation">Save</a>
    </div>
  </div>
</template>

<script>
import CityInformationService from './service';

export default {
  name: 'Contact',

  created() {
    this.changeCity();

    this.$bus.$on('CITY_CHANGED', city => {
      this.changeCity(city);
    });
  },

  props: ['city'],

  data() {
    return {
      savingCityInformation: false,
      contact: null
    };
  },

  methods: {
    changeCity(city = this.city) {
      const { contact} = city;
      this.contact = contact;
      },

    saveCityInformation() {
      this.savingCityInformation = true;
      CityInformationService.saveCityInformation(
        this.city.docId,
        this.contact,
    
      ).then(() => {
        this.savingCityInformation = false;
        this.$toast.open('Hotel information save successfully');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Contact/Contact.vue